export default __webpack_public_path__ + "media/card-checkmark.0d37b8a5.webp";